<template>
  <div class="exhibitionInfo">
    <BannerSwiper :bannerData="bannerList" />
    <div class="CYT-detail-info">
      <div class="article-content">
        <div class="article">
          <div class="detail-dec">
            <div
              class="html-show"
              ref="htmlShow"
              v-html="
                lan ? educationCentre.contentEn : educationCentre.contentCn
              "
            ></div>
            <div class="share-box" v-if="!isIndex">
              <!-- AI-Generated Begin -->
              <ShareQr
                :showApplet="false"
                :showExhibitionInfo="false"
                :showHomeStay="false"
                :showQrType="1"
              />
              <!-- AI-Generated End -->
            </div>
          </div>
        </div>
      </div>
      <div class="grey-line" v-if="exhibitionList.length > 0"></div>
      <EventExhibition
        v-if="exhibitionList.length > 0 && !isIndex"
        :showData="exhibitionList"
      />
      <WapExhibition
        v-if="exhibitionList.length > 0 && isIndex"
        :showData="exhibitionList"
      />
    </div>
  </div>
</template>
<script>
import ShareQr from "../components/shareQrCentre.vue";
import EventExhibition from "../components/eventExhibition.vue";
import WapExhibition from "../components/eapExhibition.vue";
import BannerSwiper from "../components/bannerSwiper.vue";

export default {
  name: "exhibitionInfo",
  components: {
    ShareQr,
    EventExhibition,
    BannerSwiper,
    WapExhibition,
  },
  data() {
    return {
      isIndex: false,
      content: "",
      pageIndex: 1,
      bannerList: [],
      educationCentre: {},
      exhibitionList: [],
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    pageIndex(val, oldval) {},
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      this.init();
    },
  },
  mounted() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
    this.updateFontSizeClass();
    window.addEventListener('resize', this.updateFontSizeClass);

    // 监听浏览器前进后退按钮
    window.addEventListener("popstate", this.handlePopState);
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateFontSizeClass);
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
    window.removeEventListener("popstate", this.handlePopState);
  },
  methods: {
    updateFontSizeClass() {
      const screenWidth = window.innerWidth;
      const htmlShowElement = this.$refs.htmlShow;
      
      if (!htmlShowElement) return;
      
      // 清除现有样式
      htmlShowElement.style.fontSize = '';
      const elements = htmlShowElement.querySelectorAll('*');
      elements.forEach(el => {
        el.style.fontSize = '';
        el.style.lineHeight = '';
      });
      
      // 根据屏幕宽度设置字体大小
      if (screenWidth <= 960) {
        // 小屏幕
        htmlShowElement.style.fontSize = '14px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '14px';
          p.style.lineHeight = '24px';
          p.style.marginBottom = '12px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '24px'; break;
            case 'H2': h.style.fontSize = '20px'; break;
            case 'H3': h.style.fontSize = '18px'; break;
            case 'H4': h.style.fontSize = '16px'; break;
            case 'H5': h.style.fontSize = '14px'; break;
            case 'H6': h.style.fontSize = '12px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '0px';
        });
      } else if (screenWidth <= 1440) {
        // 中等屏幕
        htmlShowElement.style.fontSize = '16px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '16px';
          p.style.lineHeight = '28px';
          p.style.marginBottom = '14px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '28px'; break;
            case 'H2': h.style.fontSize = '24px'; break;
            case 'H3': h.style.fontSize = '20px'; break;
            case 'H4': h.style.fontSize = '18px'; break;
            case 'H5': h.style.fontSize = '16px'; break;
            case 'H6': h.style.fontSize = '14px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '18px';
        });
      } else {
        // 大屏幕
        htmlShowElement.style.fontSize = '18px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '18px';
          p.style.lineHeight = '32px';
          p.style.marginBottom = '16px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '32px'; break;
            case 'H2': h.style.fontSize = '28px'; break;
            case 'H3': h.style.fontSize = '24px'; break;
            case 'H4': h.style.fontSize = '20px'; break;
            case 'H5': h.style.fontSize = '18px'; break;
            case 'H6': h.style.fontSize = '16px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '26px';
        });
      }
    },
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
      this.updateFontSizeClass();
    },
    handlePopState(event) {
      // 可以在这里添加一些返回时的特殊处理
    },
    getVideoKey() {
      return this.lan ? "videoEn" : "videoCn";
    },
    init() {
      let id = this.$route.query.id;
      this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "countryside_study_tour" },
        (res) => {
          const { data, code } = res;
          if (code == 0) {
            const videoKey = this.getVideoKey(); // 获取视频属性

            if (data[0][videoKey]) {
              this.bannerList = [
                {
                  video: data[0][videoKey],
                },
                ...JSON.parse(data[0].image),
              ];
            } else {
              this.bannerList = JSON.parse(data[0].image);
            }
            this.bannerList.forEach((el, index) => {
              el.id = index + 1;
              el.img = el.src || "";
            });
          }
        }
      );
      this.$api.get("/studyTour/detail", {}, (r) => {
        const { data, code } = r;
        if (code == 0) {
          this.educationCentre = data;
          // DOM 更新后调整字体大小
          this.$nextTick(() => {
            this.updateFontSizeClass();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.content-title {
  margin-top: 20px;
}
.exhibitionInfo {
  margin-top: 94px;
}

.CYT-detail-info {
  position: relative;
  width: 1440px;
  height: 100%;
  margin: 70px auto 60px;
  background-color: #fff;
}
.article-content {
  width: 100%;
}
.article {
  width: 100%;
  height: auto;
  padding-bottom: 50px;
}
.share-box {
  margin-top: 5px;
}
.CYT-detail-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  display: flex;
}
.detail-sub-title {
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 700;
}
.detail-dec {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 20px 0 32px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 400;
}
.html-show {
  width: 80%;
}
.grey-line {
  width: 100%;
  height: 1px;
  background: #d8d8d8;
}
.show-act-box {
  width: 100%;
  margin: 60px auto 90px;
}
.act-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.CYT-sub-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  margin: 10px 0;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: 400;
  padding-right: 15px;
  cursor: pointer;
}
.sub-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-top: 10px;
}
.title-right::after {
  content: "";
  position: absolute;
  top: 55%;
  right: 0px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(45deg);
  transform: translateY(-45%) rotate(45deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}
@media (max-width: 1440px) {
  .CYT-detail-info {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 70px auto 60px;
    background-color: #fff;
  }
  .article-content {
    width: 90%;
    margin: 0 auto;
  }
  .article {
    width: 100%;
    height: auto;
    padding-bottom: 50px;
  }
}
@media (max-width: 960px) {
  .content-title {
    margin-top: 20px;
  }
  .exhibitionInfo {
    margin-top: 80px;
  }

  .CYT-detail-info {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 30px auto 30px;
    background-color: #fff;
  }
  .article {
    width: 100%;
    margin: 40px auto;
  }
  .CYT-detail-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .detail-sub-title {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 700;
  }
  .article-content {
    width: 90%;
    margin: 0 auto;
  }
  .detail-dec {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 400;
    flex-direction: column;
  }
  .html-show {
    width: 100%;
  }
  .share-box {
    align-self: flex-end;
    margin-top: 20px;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 50px auto 0;
    background: #d8d8d8;
  }
  .CYTdetail .act-list {
    width: 95%;
    height: auto;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .content-title {
    width: 100%;
    margin-left: 30px;
  }
  .show-act-box {
    width: 100%;
    margin: 50px auto 0px;
  }
  .title-left {
    font-size: 26px;
    margin-left: 4%;
  }
  .title-right {
    position: relative;
    font-family: SourceHanSansCN-Regular;
    font-size: 20px;
    color: #98989f;
    text-align: left;
    font-weight: 400;
    padding-right: 15px;
    cursor: pointer;
  }
  .sub-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
    margin-top: 10px;
  }
  .title-right::after {
    content: "";
    position: absolute;
    top: 55%;
    right: 0px;
    width: 8px;
    height: 8px;
    border-top: 2px solid #666666;
    border-right: 2px solid #666666;
    -webkit-transform: translateY(-45%) rotate(45deg);
    transform: translateY(-45%) rotate(45deg);
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #666666;
    border-right-width: 1px;
    border-right-style: solid;
    border-right-color: #666666;
  }
}
@media (max-width: 640px) {
  .CYT-detail-title {
    font-size: 22px;
  }
  .title-left {
    font-size: 22px;
    margin-left: 0%;
  }
  .CYT-sub-title {
    font-size: 13px;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .detail-sub-title {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 12px;
  }
  .detail-dec {
    font-size: 13px;
    line-height: 24px;
    margin-bottom: 12px;
  }
  .article {
    margin: 10px auto;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 30px auto 0;
    background: #d8d8d8;
  }
  .show-act-box {
    width: 100%;
    margin: 20px auto 0px;
  }
}
</style>